export default __webpack_public_path__ + "static/media/VeggieFruit_04.7b168260.png";